import { ValueDisplayWithLabel } from '../../components/ValueDisplay'
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import { TForecast, TWeatherForecast } from './types'
import { themedUseStyletron } from '../../../theme/customTheme';
import { TiWeatherPartlySunny } from 'react-icons/ti';
import { getDimension } from './utils';
import { FormattedMessage } from 'react-intl';
import { styled } from 'baseui';
import Forecast from './Forecast';
import { HorizontalStackPanel } from '../../../components/Layout/StackPanel';

export function OverviewPanel(props: TWeatherForecast) {
    const [css, theme] = themedUseStyletron();
    const dim = getDimension(props.units);
    const forecast: TForecast = JSON.parse(props.forecast)
    return (
        <OverviewPanelWrapper height={theme.appSizes.mediumAppHeight} icon={<TiWeatherPartlySunny size='100%' color={theme.colors.backgroundPrimary}></TiWeatherPartlySunny>} {...props}>
            <MainContainer>
                <HorizontalStackPanel $alignItems={'flex-end'}>
                    <ValueDisplayWithLabel value={props.temp} label={<FormattedMessage id="SubPlants.Temperature" defaultMessage="Temperature" />} dimension={dim} ></ValueDisplayWithLabel>
                    { forecast.current.iconUrl && <div className={css({ width: theme.sizing.scale1000, height: theme.sizing.scale1000, borderRadius: '50%', background: 'white' })}>
                        <img src={`https://openweathermap.org/img/wn/${forecast.current.iconUrl}@2x.png`} className={css({ width: '100%' })} />
                    </div>}
                </HorizontalStackPanel>
                <Forecast small {...props}></Forecast>
            </MainContainer>
        </OverviewPanelWrapper>
    );
}

const MainContainer = styled('div', ({ $theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    rowGap: $theme.sizing.scale800,
    alignItems: 'center',
    width: '100%',
}));

